import {
  gtcDebounce,
} from "gtcUtils";

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.input = this.querySelector('input[type="search"]');
    this.closeButton = this.querySelector("[data-close]");
    this.predictiveSearchResults = this.querySelector("#gtc-predictive-search");
    this.resources = JSON.parse(this.querySelector("[data-resources]").textContent);
    this.requestData = {
      types: this.resources.types,
      limit: 30,
      sectionId: this.dataset.sectionId,
      options: this.resources.options,
    };

    this.triggerSearch = gtcDebounce(this.triggerSearch.bind(this), 300);
    this.debouncedGetSearchResults = gtcDebounce(this.getSearchResults.bind(this), 200);
  }

  connectedCallback() {
    this.addEventlisteners();
  }

  addEventlisteners() {

    this.input.addEventListener("input", () => {
      this.triggerSearch();
    });

    // window.addEventListener("pageshow", (event) => {
    //   if (event.persisted) {
    //     this.resetLoadingIcon();
    //   }
    // });
  }


  triggerSearch() {
    const searchTerm = this.input.value.trim();

    if (searchTerm === "") {
      document.dispatchEvent(new CustomEvent("gtcPredictiveSearch:clear", {
        bubbles: true
      }));
      this.close();
    } else {
      this.debouncedGetSearchResults(searchTerm);
    }
  };


  writeError = (error) => {
    const errorText = error.message ? error.message : 'Something went wrong';
    alert(errorText);
  }

  async getSearchResults(searchTerm) {

    const url = new URL(`${ window.location.origin }/search/suggest`);
    const params = new URLSearchParams({
      q: searchTerm,
      section_id: 'gtc-search-results',
      "resources[type]": this.requestData.types,
      "resources[limit]": this.requestData.limit,
      "resources[limit_scope]" : "each",
      "resources[options][fields]": this.requestData.options
    });

    url.search = params;

    console.dir(url.search,{ depth: null });

    try {

      const response = await fetch(url);
      const pageText = await response.text()

      if (!response.ok) {
        this.close();
        this.writeError(pageText);
        throw new Error(response.status);
      }

      const parsedHTML = new DOMParser().parseFromString(pageText, "text/html");
      const resultsMarkup = parsedHTML.querySelector("#gtc-predictive-search-results").innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      window.requestAnimationFrame(() => {
        this.open();
        document.dispatchEvent(new CustomEvent("gtcPredictiveSearch:searchComplete", {
          bubbles: true
        }));
      });

    } catch (error) {
      console.error('Error:', error);
    }
  }

  open() {
    this.predictiveSearchResults.classList.add("open");
  }

  close() {
    this.predictiveSearchResults.classList.remove("open");
  }

}

if (!customElements.get("gtc-predictive-search")) {
  customElements.define("gtc-predictive-search", PredictiveSearch);
}
